import { render } from "./Error.vue?vue&type=template&id=e1cd4fa2"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__